import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setTrainingChartWorkoutTemplateFilter, setTrainingChartPhaseFilter } from 'redux/slices/trainingChart'
import { Cog6ToothIcon } from '@heroicons/react/24/outline'

export default function TrainingChartSettings() {

    const workoutTemplateFilterOptions = [
        {
            'text': 'All',
            'value': 'strength-session-a,strength-session-b,mobility-a,mobility-b'
        },
        {
            'text': 'Strength Session A',
            'value': 'strength-session-a'
        },
        {
            'text': 'Strength Session B',
            'value': 'strength-session-b'
        },
        {
            'text': 'Mobility A',
            'value': 'mobility-a'
        },
        {
            'text': 'Mobility B',
            'value': 'mobility-b'
        }
    ]

    const phaseFilterOptions = [
        {
            'text': 'All',
            'value': 'Warm Up,Prep,Main 1,Main 2,Accessory 1,Mobility Circuit'
        },
        {
            'text': 'Warm Up',
            'value': 'Warm Up'
        },
        {
            'text': 'Prep',
            'value': 'Prep'
        },
        {
            'text': 'Main 1',
            'value': 'Main 1'
        },
        {
            'text': 'Main 2',
            'value': 'Main 2'
        },
        {
            'text': 'Accessory 1',
            'value': 'Accessory 1'
        },
        {
            'text': 'Mobility Circuit',
            'value': 'Mobility Circuit'
        }
    ]

    const dispatch = useDispatch()

    const trainingChartWorkoutTemplateFilter = useSelector(state => state.trainingChart.filters.workoutTemplateFilter)
    const trainingChartPhaseFilter = useSelector(state => state.trainingChart.filters.phaseFilter)

    const [settingsPopupVisible, setSettingsPopupVisible] = useState(false)

    return (
        <>
            <div className='absolute top-0 right-0 flex p-6 gap-x-2 z-20'>
                <Cog6ToothIcon
                    className="h-8 w-8 text-gray-500 cursor-pointer"
                    onClick={() => setSettingsPopupVisible(!settingsPopupVisible)}
                />
            </div>

            {settingsPopupVisible &&
                <div className='absolute top-4 right-16 z-10 w-64 p-4 bg-white rounded-xl border border-gray-400 shadow-xl text-base space-y-4 overflow-y-auto'>
                    <div className='space-y-1'>
                        <div className='font-semibold'>Workout Templates</div>

                        <div className='pl-2'>
                            {workoutTemplateFilterOptions.map((option, index) => (
                                <div
                                    key={index}
                                    className='flex items-center gap-x-2 cursor-pointer'
                                    onClick={() => dispatch(setTrainingChartWorkoutTemplateFilter(option.value))}
                                >
                                    <input
                                        type="radio"
                                        name="workoutTemplateSettings"
                                        value={option.value}
                                        className="h-4 w-4 text-blue-600"
                                        checked={option.value === trainingChartWorkoutTemplateFilter}
                                        readOnly={true}
                                    />
                                    <div>{option.text}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className='space-y-1'>
                        <div className='font-semibold'>Phases</div>

                        <div className='pl-2'>
                            {phaseFilterOptions.map((option, index) => (
                                <div
                                    key={index}
                                    className='flex items-center gap-x-2 cursor-pointer'
                                    onClick={() => dispatch(setTrainingChartPhaseFilter(option.value))}
                                >
                                    <input
                                        type="radio"
                                        name="phaseFilter"
                                        value={option.value}
                                        className="h-4 w-4 text-blue-600"
                                        checked={option.value === trainingChartPhaseFilter}
                                        readOnly={true}
                                    />
                                    <div>{option.text}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            }
        </>
    )
}